import React, { memo } from 'react';

import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import { grey } from '@mui/material/colors';

const StepQuestionBox = (props) => {
  const { title, label } = props;

  return (
    <Box
      {...props}
      sx={[
        {
          py: 2,
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    >
      {title && (
        <Box
          sx={{
            fontWeight: 800,
          }}
        >
          {title}
        </Box>
      )}
      {label && (
        <Box
          sx={{
            color: grey[700],
          }}
        >
          {label}
        </Box>
      )}
    </Box>
  );
};

StepQuestionBox.propTypes = {
  title: PropTypes.any,
  label: PropTypes.any,
};

export default memo(StepQuestionBox);
